export enum IVTEventsEnum {
  IVT_PARTIAL_LEAD = "ivt:partial-lead",
  IVT_LEAD_CREATED = "ivt:lead-created"
}
